import { connect } from 'react-redux';
import { Summary } from './Summary';

import { getAddGuestReservationObj } from '../../../../../store/componentStores/ManageReservation/manageReservation.selectors';
import {
  cmpDataSelector,
  getAdults,
  getArrivalDateObject,
  getBillableGuest,
  getCabanaDeposit,
  getDepartureDateObject,
  getDepositePaid,
  getIsDynamicOfferCode,
  getKids,
  getNumberOfNights,
  getOffersDiscountApplied,
  getParkingFee,
  getPointsDiscountApplied,
  getPrivateLodgingFee,
  getRateType,
  getResortFee,
  getRoomDeposit,
  getSuiteDetails,
  getSuppressRate,
  getSustainabilityFee,
  getTaxesAndFeesForReservation,
  getTotalBillAndNonBillGuest,
  getTotalRoomRate
} from '../../../../../store/componentStores/ReservationDetailsEntity/reservationDetailsEntity.selectors';
import {
  getAditionalPackagesFromAddApackage,
  getDueAtCheckinAmountWithAdditionalPackages,
  getSummaryTotalWithAdditionalPackages,
  getTaxesAmountWithAdditionalPackages,
  packagesWithAmountFromReservationData
} from '../../../../../store/reducers';

import { isEmpty } from 'lodash-es';
import { getTaxAndFeesLabels } from '../../../../../store/componentStores/LodgeConfig/lodgeConfig.selectors';
import { isArrayEmpty } from '../../../../../utilities/arraysUtils';
import { getDateMonthDayFormat } from '../../../../../utilities/dates';
import { getGuestCountLabel } from '../../../../../utilities/guestsUtils';
import { getTaxesAndFees, getTaxesAndFeesDynamic } from '../../../../../utilities/taxes';

const mapStateToProps = state => {
  const reservationDetails = cmpDataSelector(state);
  const packages = packagesWithAmountFromReservationData(state) ?? [];
  const { offerCode } = getSuiteDetails(reservationDetails);
  const hasPackages = packages && !isArrayEmpty(packages);

  const taxAndFeeLabels = getTaxAndFeesLabels(state.lodgeConfig);

  const taxesAndFeesPrices = getTaxesAndFeesForReservation(state.entities.reservationDetails);

  const taxesAndFees =
    !isEmpty(taxAndFeeLabels) && !isEmpty(taxesAndFeesPrices)
      ? getTaxesAndFeesDynamic(taxAndFeeLabels, taxesAndFeesPrices)
      : getTaxesAndFees(
          getSustainabilityFee(reservationDetails),
          getTaxesAmountWithAdditionalPackages(state),
          getResortFee(reservationDetails),
          getParkingFee(reservationDetails),
          getPrivateLodgingFee(reservationDetails)
        );

  const addGuestReservation = getAddGuestReservationObj(reservationDetails);

  const voyagerPointsDiscount = getPointsDiscountApplied(reservationDetails);
  const offersPointsDiscount = getOffersDiscountApplied(reservationDetails);
  const hasDiscountCharges = voyagerPointsDiscount || offersPointsDiscount ? true : false;

  return {
    additionalPackages: getAditionalPackagesFromAddApackage(state, true),
    checkIn: getDateMonthDayFormat(getArrivalDateObject(reservationDetails)),
    checkOut: getDateMonthDayFormat(getDepartureDateObject(reservationDetails)),
    depositPaid: getDepositePaid(reservationDetails),
    dueAtCheckinAmount: getDueAtCheckinAmountWithAdditionalPackages(state),
    guestCountText: getGuestCountLabel(
      addGuestReservation ? addGuestReservation?.guests?.adults : getAdults(reservationDetails),
      addGuestReservation ? addGuestReservation?.guests?.children?.length : getKids(reservationDetails),
      null,
      true
    ),
    addGuestReservation: addGuestReservation,
    hasAdditionalCharges: taxesAndFees && taxesAndFees.length > 0,
    hasSelectedPackages: hasPackages,
    numberOfGuests: getBillableGuest(reservationDetails),
    numberOfNights: getNumberOfNights(reservationDetails),
    packages: packages,
    promoCode: offerCode,
    resortLocation: state.currentLodge,
    suiteTotal: getTotalRoomRate(reservationDetails),
    taxesAndFees: taxesAndFees,
    total: getSummaryTotalWithAdditionalPackages(state),
    suppressRate: getSuppressRate(reservationDetails),
    cabanaDeposit: getCabanaDeposit(reservationDetails),
    roomDeposit: getRoomDeposit(reservationDetails),
    hasDiscountCharges,
    voyagerPointsDiscount,
    offersPointsDiscount,
    totalBillAndNonBillGuest: getTotalBillAndNonBillGuest(reservationDetails),
    rateType: getRateType(reservationDetails),
    isDynamicOfferCode: getIsDynamicOfferCode(reservationDetails)
  };
};

const ReservationSummary = connect(mapStateToProps, null)(Summary);

export { ReservationSummary };
